export const ICONS_DUPLICATES = {
    "addition": "t-autocredit",
    "aps": "p-aps",
    "certificate": "m-revisium_antivirus_func",
    "domain": "p-bill-domainlimit",
    "ff-calendar-a": "m-scheduler",
    "ff-plus-a": "t-new",
    "gamehost": "t-addon",
    "lv-8": "lv-16",
    "m-account": "lv-16",
    "m-aid": "t-aid",
    "m-backup2-list": "p-backup",
    "m-backup2-superlist": "p-backup",
    "m-customer": "lv-16",
    "m-db": "t-db",
    "m-directory": "m-gdpr",
    "m-domain": "p-bill-dns",
    "m-email": "p-mail",
    "m-equipment": "t-servers",
    "m-helpboard": "m-license",
    "m-mail": "p-mail",
    "m-mainmenuaccount": "lv-16",
    "m-mainmenuservice": "m-service",
    "m-mainmenutool": "t-set",
    "m-maintain": "m-productnode",
    "m-marketing": "t-stat",
    "m-mgrhelp": "m-license",
    "m-monitoring_and_journal": "t-mon",
    "m-nolicense": "t-expense",
    "m-phpversions": "p-php",
    "m-scheduler-grey": "m-scheduler",
    "m-set2": "t-set",
    "m-sslcert": "p-lock",
    "m-stat": "t-stat",
    "m-tool": "t-set",
    "m-usershell": "lv-4",
    "m-www": "m-webserver",
    "mb-addition": "t-autocredit",
    "mb-customer": "m-user",
    "mb-provider": "t-go",
    "mb-roundcube": "t-roundcube",
    "mb-site": "mb-www",
    "mbar-hideall": "ff-minus-a",
    "mbar-pin": "tab-pin",
    "mbar-popular": "p-popular",
    "mbar-showall": "t-new",
    "p-admin": "lv-29",
    "p-attr": "t-set",
    "p-auto": "t-restart",
    "p-bill-databaselimit": "t-db",
    "p-bill-emaillimit": "p-mail",
    "p-bill-webdomainlimit": "p-bill-domainlimit",
    "p-bpftp": "lv-3",
    "p-catalog": "m-file",
    "p-chat": "mb-support",
    "p-diag": "t-diag",
    "p-dmarc": "p-mail",
    "p-docker": "t-docker",
    "p-edit": "t-edit",
    "p-email": "lv-9",
    "p-excel": "l-excel",
    "p-file-0": "p-bplocal",
    "p-file-1": "p-bptar",
    "p-file-122": "p-install",
    "p-file-2": "p-bptgz",
    "p-file-204": "t-start",
    "p-file-3": "p-bptbz2",
    "p-file-300": "p-lock",
    "p-file-4": "p-bpzip",
    "p-file-6": "p-bprar",
    "p-ftp": "lv-3",
    "p-go": "t-go",
    "p-group": "t-group",
    "p-ipmi": "p-kvm",
    "p-lt1": "m-setting",
    "p-lt2": "p-additional",
    "p-lt3_grey": "p-tick-grey",
    "p-mon": "t-mon",
    "p-mysql": "t-mysql",
    "p-percent": "t-discount",
    "p-postgresql": "mb-phppgadmin",
    "p-print": "t-printd",
    "p-resell": "lv-24",
    "p-root": "lv-29",
    "p-shell": "lv-4",
    "p-stop": "t-stop",
    "p-user": "lv-16",
    "p-vnc": "t-vnc",
    "p-webserver": "m-webserver",
    "p-www": "m-webserver",
    "paidsupport": "m-support",
    "sb-help": "t-brules",
    "storage": "t-server-storages",
    "t-cloudflare": "p-cloudflare",
    "t-ddosguard": "p-ddosguard",
    "t-folder": "m-file",
    "t-folder_25": "m-file",
    "t-invoice": "t-contract",
    "t-letsencrypt": "p-letsencrypt",
    "t-phppgadmin": "mb-phppgadmin",
    "t-revisiumantivirus-s": "mb-revisiumantivirus",
    "t-sendmsg": "t-sender",
    "t-video": "p-camera"
};